import React from 'react'
import { useTranslation } from 'react-i18next'

import type { InventoryOrder } from '~/api/graphql/generated/types'
import { AlertBanner } from '~/components/elements/AlertBanner/AlertBanner'
import Typography from '~/components/elements/Typography/Typography'

import { OrderItemsPageHeaderLabels } from './order-items/OrderItemsPageHeaderLabels'

interface OrderCardProps {
  inventoryOrder: InventoryOrder
}

export const OrderCard = ({ inventoryOrder }: OrderCardProps) => {
  const { t } = useTranslation('Admin')

  return (
    <AlertBanner
      hideIcon
      content={<OrderItemsPageHeaderLabels inventoryOrder={inventoryOrder} />}
      title={
        <Typography.H3 color="brandPrimary" sx={{ mb: 1 }}>
          {t('Admin:CATALOG.ORDERS.ORDER_LABEL', {
            orderNumber: inventoryOrder.orderNumber,
          })}
        </Typography.H3>
      }
      variant="info"
    />
  )
}
